<template>
  <div class="d-flex">
    <router-link
      to="/custom-analytics"
      tag="button"
      class="link-color back-button"
      ><i class="mdi mdi-arrow-left"></i> BACK
    </router-link>
    <asc-page-title
      :style="{ position: 'relative', top: '2px' }"
      :class="{ isSticky: isSticky }"
      :title="getSurfaceTitle"
    ></asc-page-title>
  </div>
</template>

<script>
import AscPageTitle from '@/components/atoms/AscPageTitle.vue'

export default {
  name: 'AscCustomAlertsTitleWrapper',

  components: {
    AscPageTitle,
  },

  props: {
    alertType: {
      type: String,
      default: undefined,
    },
    isAdvancedFullFlight: {
      type: Boolean,
    },
    isAdvancedDplf: {
      type: Boolean,
    },
    isSticky: {
      type: Boolean,
    },
  },
  computed: {
    getSurfaceTitle() {
      return this.alertType === 'fullflight'
        ? 'SET A FULL FLIGHT DATA ANALYTIC'
        : this.alertType === 'acmf'
        ? 'SET AN ACMF DATA ANALYTIC'
        : this.isAdvancedFullFlight
        ? 'SET AN ADVANCED LOGIC FULL FLIGHT DATA ANALYTIC'
        : this.isAdvancedDplf
        ? 'SET AN ADVANCED LOGIC FAULT CODE DATA ANALYTIC'
        : 'SET AN ADVANCED LOGIC ACMF DATA ANALYTIC'
    },
  },
  methods: {},
}
</script>
<style lang="scss">
.back-button {
  border-right: 1px solid $gray-400;
  padding-right: 6px;
  margin-right: 6px;
}
</style>
